module.exports = "/assets/f9e2218f6dcdf3c4d457e4b20073857e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/KX.png
// module id = 2685
// module chunks = 0